import { PropsWithChildren } from 'react'

import { Button, Flex } from '@sequencehq/core-components'

const ControlsContainer = ({ children }: PropsWithChildren) => (
  <Flex justifyContent="flex-end" gap="8px">
    {children}
  </Flex>
)

const Cancel = ({ onClick }: { onClick: () => void }) => (
  <Button
    variant="secondary"
    onClick={onClick}
    keyboardShortcut={['Escape']}
    hideKeyboardShortcut
  >
    Cancel
  </Button>
)

const SaveAndAddAnother = ({ onClick }: { onClick: () => void }) => (
  <Button
    variant="secondary"
    onClick={onClick}
    keyboardShortcut={['Mod', 'Shift', 'Enter']}
  >
    Save and add another
  </Button>
)

const Confirm = ({
  onClick,
  label = 'Save',
  keyboardShortcut,
  'data-testid': dataTestId
}: {
  onClick: () => void
  label?: string
  keyboardShortcut?: string[]
  'data-testid'?: string
}) => (
  <Button
    variant="primary"
    onClick={onClick}
    keyboardShortcut={keyboardShortcut}
    data-testid={dataTestId}
  >
    {label}
  </Button>
)

export const Controls = Object.assign(ControlsContainer, {
  Cancel,
  SaveAndAddAnother,
  Confirm
})
